import { createFileRoute } from '@tanstack/react-router';

import { TipConfigPage } from '../modules/location-tip-config/ui/pages/TipConfigPage';

// NOTE: .index.tsx suffix is REQUIRED (same pattern as checkin-config + hotel-config + tariff routes).
// Without the .index suffix, TanStack Router treats the file as a layout component.
export const Route = createFileRoute('/_authenticated/dashboard/locations/$locationId/tip-config/')(
  {
    component: TipConfigPage,
    staticData: {
      breadcrumb: ['Manage', 'Locations', 'Tip Configuration'],
    },
  },
);
